export var CartActionTypeEnum;
(function (CartActionTypeEnum) {
    CartActionTypeEnum["ADD_ITEM"] = "ADD_ITEM";
    CartActionTypeEnum["SET_NOTES"] = "SET_NOTES";
    CartActionTypeEnum["UPDATE_ITEM"] = "UPDATE_ITEM";
    CartActionTypeEnum["REMOVE_ITEM"] = "REMOVE_ITEM";
    CartActionTypeEnum["ADD_ITEM_BUNDLE"] = "ADD_ITEM_BUNDLE";
    CartActionTypeEnum["UPDATE_ITEM_BUNDLE"] = "UPDATE_ITEM_BUNDLE";
    CartActionTypeEnum["REMOVE_ITEM_BUNDLE"] = "REMOVE_ITEM_BUNDLE";
    CartActionTypeEnum["SET_GRATUITY"] = "SET_GRATUITY";
    CartActionTypeEnum["ADD_PROMOTION"] = "ADD_PROMOTION";
    CartActionTypeEnum["SET_RECIPIENT"] = "SET_RECIPIENT";
    CartActionTypeEnum["UPDATE_PROMOTION"] = "UPDATE_PROMOTION";
    CartActionTypeEnum["REMOVE_PROMOTION"] = "REMOVE_PROMOTION";
    CartActionTypeEnum["ADD_SERVICE_CHARGE"] = "ADD_SERVICE_CHARGE";
    CartActionTypeEnum["APPLY_PROMOCODE"] = "APPLY_PROMOCODE";
    CartActionTypeEnum["APPLY_PROMOTION"] = "APPLY_PROMOTION";
    CartActionTypeEnum["SET_DELIVERY_ADDRESS"] = "SET_DELIVERY_ADDRESS";
    CartActionTypeEnum["SET_DINING_OPTION"] = "SET_DINING_OPTION";
    CartActionTypeEnum["SET_DINING_OPTION_DETAILS"] = "SET_DINING_OPTION_DETAILS";
    CartActionTypeEnum["SET_DELAYED_INFO"] = "SET_DELAYED_INFO";
    CartActionTypeEnum["VALIDATE_CART"] = "VALIDATE_CART";
    CartActionTypeEnum["CHECK_PROMOTIONS"] = "CHECK_PROMOTIONS";
    CartActionTypeEnum["COPY_ORDER"] = "COPY_ORDER";
    CartActionTypeEnum["RESTORE_LINK"] = "RESTORE_LINK";
    CartActionTypeEnum["ADD_GIFTCARD"] = "ADD_GIFTCARD";
    CartActionTypeEnum["UPDATE_GIFTCARD"] = "UPDATE_GIFTCARD";
    CartActionTypeEnum["REMOVE_GIFTCARD"] = "REMOVE_GIFTCARD";
    CartActionTypeEnum["ADD_ITEM_COMBO"] = "ADD_ITEM_COMBO";
    CartActionTypeEnum["REMOVE_ITEM_COMBO"] = "REMOVE_ITEM_COMBO";
    CartActionTypeEnum["UPDATE_ITEM_COMBO"] = "UPDATE_ITEM_COMBO";
    CartActionTypeEnum["SET_GUEST_RECIPIENT"] = "SET_GUEST_RECIPIENT";
})(CartActionTypeEnum || (CartActionTypeEnum = {}));
//# sourceMappingURL=CartActionTypeEnum.js.map